import { render, staticRenderFns } from "./DialogErrorIcon.vue?vue&type=template&id=ff67133e"
import script from "./DialogErrorIcon.vue?vue&type=script&lang=ts"
export * from "./DialogErrorIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports